import { render, staticRenderFns } from "./relatorio_extrato_conta_corrente.vue?vue&type=template&id=f8f43cd6&scoped=true&"
import script from "./relatorio_extrato_conta_corrente.vue?vue&type=script&lang=js&"
export * from "./relatorio_extrato_conta_corrente.vue?vue&type=script&lang=js&"
import style0 from "./relatorio_extrato_conta_corrente.vue?vue&type=style&index=0&id=f8f43cd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f43cd6",
  null
  
)

export default component.exports